var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 59",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "086---Desktop-Calendar",
    fillRule: "nonzero",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 57.0000098 4.892-.0000098c.6090093.0018564 1.1888296-.2607623 1.5891056-.7197557s.5815789-1.0691487.4968944-1.6722443l-5.978-41.608z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#f0c419",
    height: 54,
    rx: 3,
    width: 52,
    y: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 12v6h-44v-6c.0032948-1.1032019.89679813-1.9967052 2-2h40c1.1032019.0032948 1.9967052.8967981 2 2z",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 18v30.17c-.0002413.5329123-.2125227 1.0438267-.59 1.42l-5.82 5.82c-.3761733.3774773-.8870877.5897587-1.42.59h-34.17c-1.10320187-.0032948-1.9967052-.8967981-2-2v-36z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18 45c3.3123376-.0033074 5.9966926-2.6876624 6-6v-8c-.0000001-3.3137084-2.6862916-5.9999999-6-5.9999999s-5.9999999 2.6862915-6 5.9999999v8c.0033074 3.3123376 2.6876624 5.9966926 6 6zm-4-14c0-2.209139 1.790861-4 4-4s4 1.790861 4 4v8c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 43c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-3v-17c-.0000863-.4043959-.2437275-.7689341-.6173454-.923678-.373618-.1547439-.8036603-.0692299-1.0896546.216678l-4 4c-.3789722.3923789-.3735524 1.0160848.0121814 1.4018186s1.0094397.3911536 1.4018186.0121814l2.293-2.293v14.586z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 48h-23c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h23c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47.82 49c-.100256.2196188-.2391253.4194552-.41.59l-5.82 5.82c-.1705448.1708747-.3703812.309744-.59.41v-4.82c.0032948-1.1032019.8967981-1.9967052 2-2z",
    fill: "#d1d4d1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#95a5a5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23.66 6h-2.09c-.999535-2.29020097-3.5363928-3.49084994-5.9411927-2.81185922-2.4047998.67899072-3.939101 3.02912374-3.5932557 5.50389279.3458453 2.47476903 2.4656384 4.31424783 4.9644484 4.30796643.5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-3.5603924.0004277-6.5539029-2.6717472-6.9560462-6.20935582-.40214335-3.53760863 1.9152107-6.81350454 5.3848555-7.61222763 3.4696449-.79872308 6.9860886 1.13421437 8.1711907 4.49158345.0400741.10538801.0604128.21725073.06.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.66 6h-2.09c-.999535-2.29020097-3.5363928-3.49084994-5.9411927-2.81185922-2.4047998.67899072-3.939101 3.02912374-3.5932557 5.50389279.3458453 2.47476903 2.4656384 4.31424783 4.9644484 4.30796643.5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-3.5603924.0004277-6.5539029-2.6717472-6.9560462-6.20935582-.4021434-3.53760863 1.9152107-6.81350454 5.3848555-7.61222763 3.4696449-.79872308 6.9860886 1.13421437 8.1711907 4.49158345.0400741.10538801.0604128.21725073.06.33z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.e43bd626.svg";
export { ForwardRef as ReactComponent };